import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function AtendenteLogin() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setErro('');
    setLoading(true);
    try {
      const r = await axios.post(`${API_URL}/api/funcionarios/login`, { email, senha });
      localStorage.setItem('funcionario_token', r.data.token);
      localStorage.setItem('funcionario_dados', JSON.stringify(r.data.funcionario));
      navigate('/atendente/mesas');
    } catch (err) {
      setErro(err.response?.data?.error || 'Erro ao fazer login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1a0000, #0a0a0a)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 20
    }}>
      <div style={{
        background: 'var(--bg2, #1a1a1a)',
        borderRadius: 16,
        padding: 30,
        maxWidth: 400,
        width: '100%',
        boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
        border: '1px solid var(--border, #333)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 60, marginBottom: 8 }}>🧑‍🍳</div>
          <h1 style={{
            fontSize: 26, fontWeight: 800,
            background: 'linear-gradient(90deg,#e63946,#FF6B00)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: 4
          }}>Área do Atendente</h1>
          <p style={{ color: 'var(--text2, #999)', fontSize: 13 }}>Faça login pra abrir mesas</p>
        </div>

        {erro && (
          <div style={{
            background: 'rgba(230,57,70,0.15)',
            border: '1px solid rgba(230,57,70,0.4)',
            color: '#ff6b7a', padding: 10, borderRadius: 8,
            fontSize: 13, marginBottom: 14, textAlign: 'center'
          }}>{erro}</div>
        )}

        <form onSubmit={handleLogin}>
          <label style={{ fontSize: 12, color: 'var(--text2)', display: 'block', marginBottom: 4 }}>Email</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
            style={{
              width: '100%', padding: '12px 14px', marginBottom: 12,
              background: 'var(--bg4, #222)', border: '1px solid var(--border, #333)',
              color: 'var(--text, #fff)', borderRadius: 8, fontSize: 14
            }} />

          <label style={{ fontSize: 12, color: 'var(--text2)', display: 'block', marginBottom: 4 }}>Senha</label>
          <input type="password" value={senha} onChange={e => setSenha(e.target.value)} required
            style={{
              width: '100%', padding: '12px 14px', marginBottom: 20,
              background: 'var(--bg4, #222)', border: '1px solid var(--border, #333)',
              color: 'var(--text, #fff)', borderRadius: 8, fontSize: 14
            }} />

          <button type="submit" disabled={loading} style={{
            width: '100%', padding: 14,
            background: 'linear-gradient(90deg, #e63946, #FF6B00)',
            border: 'none', color: '#fff', borderRadius: 8,
            fontSize: 15, fontWeight: 700, cursor: 'pointer',
            opacity: loading ? 0.7 : 1
          }}>{loading ? 'Entrando...' : 'Entrar'}</button>
        </form>
      </div>
    </div>
  );
}
